"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeatFirstInitiative = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const Turmoil_1 = require("../../../turmoil/Turmoil");
const PartyName_1 = require("../../../turmoil/parties/PartyName");
const Resources_1 = require("../../../Resources");
const Card_1 = require("../../Card");
class HeatFirstInitiative extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.HEAT_FIRST_INITIATIVE,
            metadata: {
                cardNumber: 'Y37',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.delegates(2).kelvinists();
                    b.temperature(2);
                }),
                description: 'Place 2 delegates into Kelvinists and raise the temperature 2 steps.',
            },
        });
    }
    canPlay(player) {
        const turmoil = Turmoil_1.Turmoil.getTurmoil(player.game);
        const party = turmoil.parties.find((p) => p.name === PartyName_1.PartyName.KELVINISTS);
        if (party === undefined)
            Card_1.Card.setSocietyWarningText(this, PartyName_1.PartyName.KELVINISTS);
        return true;
    }
    play(player) {
        const game = player.game;
        const turmoil = Turmoil_1.Turmoil.getTurmoil(game);
        if (turmoil.parties.find((p) => p.name === PartyName_1.PartyName.KELVINISTS)) {
            turmoil.sendDelegateToParty(player.id, PartyName_1.PartyName.KELVINISTS, game, 'reserve');
            turmoil.sendDelegateToParty(player.id, PartyName_1.PartyName.KELVINISTS, game, 'reserve');
        }
        else {
            player.addResource(Resources_1.Resources.MEGACREDITS, 7, { log: true });
        }
        game.increaseTemperature(player, 2);
        return undefined;
    }
}
exports.HeatFirstInitiative = HeatFirstInitiative;
//# sourceMappingURL=HeatFirstInitiative.js.map